var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 40,
    viewBox: "0 0 128 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 40H4C1.8 40 0 38.2 0 36V4C0 1.8 1.8 0 4 0H124C126.2 0 128 1.8 128 4V36C128 38.2 126.2 40 124 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80078 19.6V9.1C9.80078 8.5 10.3008 8 10.8008 8C11.3008 8 11.5008 8.1 11.8008 8.3L31.1008 18.9C31.5008 19.1 31.7008 19.4 31.7008 19.7C31.7008 20 31.5008 20.3 31.1008 20.5L11.8008 31.1C11.6008 31.2 11.3008 31.4 10.8008 31.4C10.3008 31.4 9.80078 30.9 9.80078 30.3V19.6Z",
    fill: "url(#paint0_linear_1638_130648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2996 19.7L10.5996 8C10.6996 8 10.6996 8 10.7996 8C11.2996 8 11.4996 8.1 11.7996 8.3L25.9996 16.1L22.2996 19.7Z",
    fill: "url(#paint1_linear_1638_130648)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9008 23.2004L22.3008 19.6004L26.0008 15.9004L31.1008 18.7004C31.5008 18.9004 31.7008 19.2004 31.7008 19.5004C31.7008 19.8004 31.5008 20.1004 31.1008 20.3004L25.9008 23.2004Z",
    fill: "url(#paint2_linear_1638_130648)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6992 31.1996L22.2992 19.5996L25.8992 23.1996L11.7992 30.8996C11.4992 31.0996 11.2992 31.1996 10.6992 31.1996C10.7992 31.1996 10.7992 31.1996 10.6992 31.1996Z",
    fill: "url(#paint3_linear_1638_130648)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1004 33.9C70.6004 33.5 70.2004 32.8 70.0004 32.4L71.6004 31.7C71.7004 31.9 71.9004 32.2 72.1004 32.5C72.5004 32.9 73.1004 33.3 73.7004 33.3C74.3004 33.3 75.0004 33 75.4004 32.5C75.7004 32 75.9004 31.5 75.9004 30.8V30.2C74.7004 31.7 72.2004 31.5 70.8004 29.9C69.3004 28.3 69.3004 25.6 70.8004 24C72.3004 22.5 74.5004 22.3 75.8004 23.7V23H77.5004V30.5C77.5004 32.4 76.8004 33.5 75.9004 34.2C75.3004 34.7 74.4004 34.9 73.6004 34.9C72.7004 34.8 71.8004 34.5 71.1004 33.9ZM113 34.3L114.7 30.3L111.7 23.4H113.4L115.5 28.3L117.6 23.4H119.3L114.7 34.3H113ZM104.9 30.5C104.4 30 104.2 29.3 104.2 28.6C104.2 28 104.4 27.4 104.8 27C105.5 26.3 106.5 26 107.6 26C108.3 26 108.9 26.1 109.4 26.4C109.4 25.2 108.4 24.7 107.6 24.7C106.9 24.7 106.2 25.1 105.9 25.8L104.4 25.2C104.7 24.5 105.5 23.2 107.5 23.2C108.5 23.2 109.5 23.5 110.1 24.2C110.7 24.9 110.9 25.7 110.9 26.8V31H109.2V30.3C109 30.6 108.6 30.8 108.3 31C107.9 31.2 107.4 31.3 106.9 31.3C106.3 31.2 105.4 31 104.9 30.5ZM51.6004 26.9C51.6004 24.9 53.1004 22.7 55.8004 22.7C58.4004 22.7 60.0004 24.9 60.0004 26.9C60.0004 28.9 58.5004 31.1 55.8004 31.1C53.1004 31.1 51.6004 28.9 51.6004 26.9ZM60.6004 26.9C60.6004 24.9 62.1004 22.7 64.8004 22.7C67.4004 22.7 69.0004 24.9 69.0004 26.9C69.0004 28.9 67.5004 31.1 64.8004 31.1C62.2004 31.1 60.6004 28.9 60.6004 26.9ZM40.3004 29.1C37.8004 26.6 37.9004 22.5 40.4004 19.9C41.7004 18.6 43.3004 18 45.0004 18C46.6004 18 48.2004 18.6 49.4004 19.8L48.2004 21.1C46.4004 19.3 43.5004 19.4 41.8004 21.2C40.0004 23.1 40.0004 26 41.8004 27.9C43.6004 29.8 46.6004 29.9 48.4004 28C49.0004 27.4 49.2004 26.6 49.3004 25.8H45.1004V24H51.0004C51.1004 24.4 51.1004 24.9 51.1004 25.4C51.1004 26.9 50.5004 28.4 49.5004 29.4C48.4004 30.5 46.8004 31.1 45.2004 31.1C43.4004 31 41.6004 30.4 40.3004 29.1ZM82.6004 29.8C81.1004 28.2 81.1004 25.5 82.6004 23.8C84.1004 22.2 86.6004 22.2 88.0004 23.8C88.5004 24.3 88.8004 25 89.1004 25.7L83.6004 28C83.9004 28.7 84.6004 29.3 85.6004 29.3C86.5004 29.3 87.1004 29 87.7004 28.1L89.2004 29.1C89.0004 29.3 88.8004 29.5 88.7004 29.7C87.0004 31.4 84.1004 31.4 82.6004 29.8ZM93.0004 31V19.9H96.6004C98.7004 19.9 100.4 21.4 100.4 23.2C100.4 25 98.9004 26.5 97.0004 26.5H94.8004V30.9H93.0004V31ZM101.4 31V19.9H103.1V31H101.4ZM78.8004 30.8V18.4H80.6004V30.8H78.8004ZM109.3 27.7C108.9 27.4 108.3 27.3 107.7 27.3C106.5 27.3 105.8 27.9 105.8 28.6C105.8 29.3 106.5 29.7 107.2 29.7C108.2 29.7 109.3 28.9 109.3 27.7ZM58.1004 26.9C58.1004 25.7 57.3004 24.4 55.8004 24.4C54.3004 24.4 53.5004 25.7 53.5004 26.9C53.5004 28.1 54.3004 29.4 55.8004 29.4C57.2004 29.4 58.1004 28.1 58.1004 26.9ZM67.1004 26.9C67.1004 25.7 66.3004 24.4 64.8004 24.4C63.3004 24.4 62.5004 25.7 62.5004 26.9C62.5004 28.1 63.3004 29.4 64.8004 29.4C66.3004 29.4 67.1004 28.1 67.1004 26.9ZM76.0004 27.6C76.0004 27.5 76.0004 27.4 76.1004 27.3C76.1004 27.2 76.1004 27 76.1004 26.9C76.1004 26.8 76.1004 26.6 76.1004 26.5V26.4C76.1004 26.3 76.0004 26.1 76.0004 26C75.7004 25 74.8004 24.3 73.9004 24.3C72.7004 24.3 71.7004 25.5 71.7004 26.8C71.7004 28.2 72.7004 29.3 74.0004 29.3C74.8004 29.4 75.6004 28.7 76.0004 27.6ZM83.3004 26.7L87.0004 25.1C86.6004 24.4 86.0004 24.2 85.5004 24.2C84.0004 24.3 83.1004 25.9 83.3004 26.7ZM98.6004 23.3C98.6004 22.3 97.8004 21.6 96.7004 21.6H94.7004V25.1H96.8004C97.8004 25.1 98.6004 24.3 98.6004 23.3Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.3 32.3H114.2V32.2H114.3H114.2V32.3H114.3Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.601 32.2H114.501H114.601V32.3V32.2Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9004 10.1002C38.9004 8.3002 40.2004 7.2002 41.8004 7.2002C42.9004 7.2002 43.6004 7.7002 44.1004 8.4002L43.3004 8.9002C43.0004 8.5002 42.5004 8.2002 41.8004 8.2002C40.7004 8.2002 39.9004 9.0002 39.9004 10.2002C39.9004 11.4002 40.7004 12.2002 41.8004 12.2002C42.4004 12.2002 42.9004 11.9002 43.1004 11.7002V10.8002H41.5004V9.9002H44.2004V12.0002C43.7004 12.6002 42.9004 13.0002 41.9004 13.0002C40.2004 13.0002 38.9004 11.8002 38.9004 10.1002Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4004 12.8998V7.2998H49.2004V8.1998H46.3004V9.5998H49.1004V10.4998H46.3004V12.0998H49.2004V12.9998L45.4004 12.8998Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0008 12.8998V8.1998H50.3008V7.2998H54.7008V8.1998H53.0008V12.8998H52.0008Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0996 12.8998V7.2998H59.0996V12.8998H58.0996Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7996 12.8998V8.1998H60.0996V7.2998H64.4996V8.1998H62.7996V12.8998H61.7996Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5992 7.2002C68.8992 7.2002 67.6992 8.4002 67.6992 10.1002C67.6992 11.7002 68.8992 13.0002 70.5992 13.0002C72.2992 13.0002 73.4992 11.8002 73.4992 10.1002C73.4992 8.4002 72.2992 7.2002 70.5992 7.2002ZM70.4992 8.1002C71.6992 8.1002 72.3992 8.9002 72.3992 10.1002C72.3992 11.2002 71.6992 12.1002 70.4992 12.1002C69.2992 12.1002 68.5992 11.3002 68.5992 10.1002C68.5992 9.0002 69.3992 8.1002 70.4992 8.1002Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4996 12.8998L75.5996 8.8998V12.8998H74.5996V7.2998H75.5996L78.4996 11.1998V7.2998H79.4996V12.8998H78.4996Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1638_130648",
    x1: 5.50962,
    y1: 9.56442,
    x2: 11.8441,
    y2: 32.3506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AD1D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1638_130648",
    x1: 4.01247,
    y1: 15.6391,
    x2: 16.2543,
    y2: 27.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24BBB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1638_130648",
    x1: 32.1126,
    y1: 23.6205,
    x2: 32.1126,
    y2: 15.6721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1638_130648",
    x1: 20.4297,
    y1: 37.8674,
    x2: 28.6903,
    y2: 23.4326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#712B8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1D27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
export default __webpack_public_path__ + "static/media/google-play-badge.baae67d6382df6ba4e510ca3166bf263.svg";
export { ForwardRef as ReactComponent };